import React, { useRef, useEffect } from 'react';
import '../styles/index.css';
export const SegmentedControl = ({ name, options, value, onChange }) => {
    const controlRef = useRef(null);
    const sliderRef = useRef(null);
    // 防止移动端点击时页面滚动和元素上移，但不影响点击功能
    const handleTouchStart = (e) => {
        // 只阻止多点触控的默认行为，防止页面缩放
        if (e.touches.length > 1) {
            e.preventDefault();
        }
        // 阻止事件冒泡，防止父元素的滚动行为
        e.stopPropagation();
        // 记录触摸开始位置，用于判断是否为点击操作
        const touch = e.touches[0];
        e.currentTarget.dataset.touchStartX = touch.clientX.toString();
        e.currentTarget.dataset.touchStartY = touch.clientY.toString();
    };
    // 防止移动端点击时页面滚动和元素上移，但不影响点击功能
    const handleTouchMove = (e) => {
        // 只阻止多点触控的默认行为，防止页面缩放
        if (e.touches.length > 1) {
            e.preventDefault();
        }
        // 获取触摸开始位置
        const touchStartX = parseFloat(e.currentTarget.dataset.touchStartX || '0');
        const touchStartY = parseFloat(e.currentTarget.dataset.touchStartY || '0');
        // 计算触摸移动距离
        const touch = e.touches[0];
        const deltaX = Math.abs(touch.clientX - touchStartX);
        const deltaY = Math.abs(touch.clientY - touchStartY);
        // 如果移动距离超过阈值，则认为是滑动操作，阻止默认行为
        if (deltaX > 5 || deltaY > 5) {
            e.preventDefault();
        }
        // 阻止事件冒泡，防止父元素的滚动行为
        e.stopPropagation();
    };
    // 防止移动端点击时页面滚动和元素上移，但不影响点击功能
    const handleTouchEnd = (e) => {
        // 阻止事件冒泡，防止父元素的滚动行为
        e.stopPropagation();
        // 清除触摸开始位置记录
        delete e.currentTarget.dataset.touchStartX;
        delete e.currentTarget.dataset.touchStartY;
    };
    useEffect(() => {
        if (!controlRef.current)
            return;
        const activeElement = controlRef.current.querySelector('.segmented-control-input:checked');
        if (!activeElement)
            return;
        const buttonElement = activeElement.nextElementSibling;
        if (!buttonElement || !sliderRef.current)
            return;
        // 使用 requestAnimationFrame 确保在浏览器重绘后计算位置
        const updateSliderPosition = () => {
            if (!controlRef.current)
                return;
            const buttonRect = buttonElement.getBoundingClientRect();
            const controlRect = controlRef.current.getBoundingClientRect();
            // 直接设置滑块样式，而不是使用状态
            sliderRef.current.style.width = `${buttonRect.width}px`;
            sliderRef.current.style.left = `${buttonRect.left - controlRect.left}px`;
            sliderRef.current.style.opacity = '1';
        };
        // 立即更新一次
        updateSliderPosition();
        // 使用 requestAnimationFrame 确保在下一帧再次更新，处理可能的布局变化
        const animationId = requestAnimationFrame(updateSliderPosition);
        // 添加 resize 监听器，处理窗口大小变化
        const resizeObserver = new ResizeObserver(() => {
            updateSliderPosition();
        });
        resizeObserver.observe(controlRef.current);
        // 清理函数
        return () => {
            cancelAnimationFrame(animationId);
            resizeObserver.disconnect();
        };
    }, [value, options]);
    // 处理按钮点击事件，防止移动端的默认行为
    const handleButtonClick = (optionValue) => (e) => {
        // 阻止事件冒泡和默认行为
        e.preventDefault();
        e.stopPropagation();
        // 调用 onChange 回调
        onChange(optionValue);
    };
    return (React.createElement("div", { className: "segmented-control", ref: controlRef, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd },
        React.createElement("div", { className: "segmented-control-slider", ref: sliderRef }),
        options.map((option) => (React.createElement("label", { key: option.value, className: "segmented-control-label" },
            React.createElement("input", { type: "radio", name: name, value: option.value, checked: value === option.value, onChange: () => onChange(option.value), className: "segmented-control-input" }),
            React.createElement("span", { className: "segmented-control-button", onClick: handleButtonClick(option.value), onTouchEnd: handleButtonClick(option.value) }, option.label))))));
};
